<template>
  <v-menu
    v-model="showMenu"
    content-class="module-menu menu-dark"
    :attach="`#mc-${module.uuid}`"
    absolute
    offset-y
    :position-x="-10"
    :position-y="42"
    min-width="270"
    max-width="270"
    dark
    style="left: 0">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :id="`mc-${module.uuid}`"
        class="module-move btn-small btn-gray-border"
        icon
        outlined
        :ripple="false"
        v-bind="attrs"
        v-on="on">
        <IconSixDots />
      </v-btn>
    </template>
    <v-list>
      <template>
        <v-list-item
          v-show="btnUpShow"
          class="module-menu-item"
          link
          :ripple="false"
          @click.stop="swapModule($event, 'up')">
          <IconArrowUp size="24" />
          {{ $t('move-up') }}
        </v-list-item>
        <v-list-item
          v-show="btnDownShow"
          class="module-menu-item"
          link
          :ripple="false"
          @click.stop="swapModule($event, 'down')">
          <IconArrowDown size="24" />
          {{ $t('move-down') }}
        </v-list-item>
      </template>
      <v-list-item
        class="module-menu-item"
        link
        :ripple="false"
        @click.stop="cloneModule">
        <div class="module-menu-icon">
          <IconCopy />
        </div>
        {{ $t('clone') }}
      </v-list-item>
      <v-list-item
        class="module-menu-item"
        link
        :ripple="false"
        @click.stop="showCodeEditor">
        <div class="module-menu-icon">
          <IconCode />
        </div>
        {{ $t('view-the-code') }}
      </v-list-item>
      <v-list-item
        class="module-menu-item"
        link
        :ripple="false"
        @click.stop="deleteModule">
        <div class="module-menu-icon">
          <IconDelete />
        </div>
        {{ $t('delete') }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
/* eslint-disable */
import IconDelete from '@/components/icons/IconDelete'
import IconCode from '@/components/icons/IconCode'
import IconCopy from '@/components/icons/IconCopy'
import IconSixDots from '@/components/icons/IconSixDots'
import IconArrowUp from '@/components/icons/IconArrowUp'
import IconArrowDown from '@/components/icons/IconArrowDown'

import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'LetterModuleControls',
  components: {
    IconArrowDown,
    IconArrowUp,
    IconSixDots,
    IconDelete,
    IconCode,
    IconCopy,
  },
  props: {
    uuid: String,
  },
  data() {
    return {
      showMenu: false,
      btnUpShow: false,
      btnDownShow: false,
    }
  },
  computed: {
    module() {
      return this.$store.getters['letter/getLetterModuleByUuid'](this.uuid)
    },
    modulesLength() {
      return this.$store.getters['letter/getLetterModulesSize']
    },
    position() {
      return this.module.position
    },
  },
  watch: {
    // Отработает при перемещение модуля
    position() {
      this.moduleSwapShow()
    },
    // Отработает при клонирование/удаление модуля
    modulesLength() {
      this.moduleSwapShow()
    },
  },
  mounted() {
    this.moduleSwapShow()
  },
  methods: {
    showCodeEditor() {
      this.showMenu = false
      this.$store.commit('editor/toggleCodeEditor')
    },
    moduleSwapShow() {
      this.btnDownShow = this.position < this.modulesLength - 1
      this.btnUpShow = this.position > 0
    },
    // Перемещение модуля вверх/вниз (way = направление)
    swapModule(e, way) {
      let indexForPush = null
      const $modules = document.querySelectorAll('.editor-module')
      const $targetModule = e.target.closest('.editor-module')

      if (way === 'up') {
        indexForPush = this.position > 0 ? this.position - 1 : 0
      } else {
        indexForPush =
          this.position < this.modulesLength
            ? this.position + 2
            : this.modulesLength
      }

      const $dropZoneModule = $modules[indexForPush]
      const $workarea = $targetModule.parentNode
      $workarea.insertBefore($targetModule, $dropZoneModule)

      this.$nextTick(function () {
        this.$store.commit('letter/updateModulesPosition')
      })
    },
    // Клонирование модуля
    cloneModule() {
      const module = {
        ...this.module,
      }
      const oldUuid = module.uuid
      module.uuid = uuidv4()
      module.position++

      this.$store.dispatch('letter/cloneModule', {
        index: this.position + 1,
        module,
        oldUuid,
      })
      this.$store.commit('editor/toggleModuleRefresh', module.uuid)
    },
    // Удаление модуля
    deleteModule() {
      this.$store.commit('editor/clearSelected')
      this.$store.commit('letter/deleteModule', {
        uuid: this.module.uuid,
      })
    },
  },
}
</script>

<style lang="scss">
.module-menu {
  border: 1px solid #151515;
  &:before,
  &:after {
    top: -8px;
    left: 19px;
  }
}

.module-move {
  &.v-btn:focus::before {
    opacity: 0;
  }
}
</style>
<i18n>
{
  "ru": {
    "move-up": "Переместить вверх",
    "move-down": "Переместить вниз",
    "clone": "Клонировать",
    "view-the-code": "Смотреть код",
    "delete": "Удалить"
  },
  "en": {
    "move-up": "Move up",
    "move-down": "Move down",
    "clone": "Clone",
    "view-the-code": "View the code",
    "delete": "Delete"
  }
}
</i18n>
